import { FormInput } from "semantic-ui-react";

export const NewIntTextInputFormComponent = (props: {
  props: NewIntTextInputFormComponentProps;
  data: any;
  setData: any;
}) => {
  const charIsInt = (char: string) => {
    const numberChars = "0123456789";
    return numberChars.includes(char);
  };

  const stringIsInt = (str: string) => {
    for (const char of str) {
      if (!charIsInt(char)) {
        return false;
      }
    }
    return true;
  };
  return (
    <FormInput
      fluid
      label={props.props.label}
      required={props.props.required}
      placeholder={props.props.placeholder}
      value={props.data[props.props.key]}
      onChange={(e) => {
        const newValue = e.target.value;
        if (newValue === "") {
          props.setData({ ...props.data, [props.props.key]: "" });
        } else {
          if (stringIsInt(newValue)) {
            props.setData({
              ...props.data,
              [props.props.key]: Number(newValue),
            });
          }
        }
      }}
    />
  );
};

export type NewIntTextInputFormComponentProps = {
  type: "int_text";
  key: string;
  label: string;
  required: boolean;
  placeholder: string;
};
